'use client';

import {apiError} from '@/utils/constants';
import styles from './Error.module.scss';
import Link from 'next/link';

export default function CustomError() {
  return (
    <div className={styles['error-container']}>
      <p className={styles['error-container__content']}>
        {apiError.errorMessage1}{' '}
        <Link
          className={styles['error-container__link-text']}
          href={apiError.supportLinkURL}
          target="_blank"
        >
          {apiError.supportLinkText}
        </Link>
        {apiError.errorMessage2}
      </p>
    </div>
  );
}
